import React from 'react';
import { WordpressPost } from '@benzinga/content-manager';
import { CornerstoneNavigation } from '@benzinga/navigation-ui';
import { MoneyBlocksLayout } from './MoneyBlocksLayout';

export interface MoneyLeftSidebarProps {
  post: WordpressPost;
}

export const showLeftSidebar = (post: WordpressPost | null) => {
  if (!(!post || !post.cornerstone || !post.cornerstone?.child_posts?.length)) {
    return true;
  } else if (post?.left_sidebar?.blocks?.length) {
    return true;
  }
  return false;
};

export const MoneyLeftSidebar: React.FC<MoneyLeftSidebarProps> = ({ post }) => {
  return (
    <>
      <CornerstoneNavigation post={post} />
      <MoneyBlocksLayout post={post.left_sidebar} />
    </>
  );
};
